import { useEffect, useState } from "react";

import type { StreamTopic } from "../contract/types";
import type { StreamClient, StreamStatus } from "../api/stream";
import { useBackend } from "./BackendProvider";

export interface StreamHandleState {
  /** Client démarré, ou `null` avant montage. */
  stream: StreamClient | null;
  status: StreamStatus;
}

/**
 * Ouvre un flux temps réel pour le réseau et les sujets donnés, le démarre, et
 * suit son état de connexion. Le client est recréé si le réseau ou la liste des
 * sujets change ; il est arrêté au démontage.
 */
export function useStream(networkId: string, topics: StreamTopic[]): StreamHandleState {
  const backend = useBackend();
  const topicsKey = [...topics].sort().join(",");
  const [state, setState] = useState<StreamHandleState>({ stream: null, status: "idle" });

  useEffect(() => {
    const client = backend.createStream(networkId, topics);
    const off = client.on("status", (status) => setState((s) => ({ ...s, status })));
    setState({ stream: client, status: client.status });
    client.start();
    return () => {
      off();
      client.stop();
      setState({ stream: null, status: "closed" });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backend, networkId, topicsKey]);

  return state;
}
